import React, { useState, useEffect, useMemo } from "react";
import "./tournament-elite.css";
import Jersey from "./assets/images/OFFICIAL_JERSEY.jpg"
import Jersey2 from "./assets/images/OFFICIAL_JERSEY.jpg"
import Sibol from "./assets/images/SIBOL_LOGO.png"
import SibolIcon from "./assets/images/SIBOL_ICON_WHT.png"
import VideoBG from "./assets/videos/sibol2.mp4"
import { db } from "../../firebase";
import { collection, addDoc, query, where, getDocs, doc, updateDoc, orderBy } from "firebase/firestore";
import { serverTimestamp } from "firebase/firestore";
import AppHeader from "../../components/layout/AppHeader"
import BottomNav from "../../components/layout/BottomNav"
import { CLUB_ID, THEME_COLOR } from "../../config/club";
import { useAuth } from "../../context/AuthContext";
import QR1099 from "./assets/images/QR_1099.jpg";
import QR1199 from "./assets/images/QR_1199.jpg";
import AuthLanding from "../../components/player/AuthLanding";
import Swal from "sweetalert2";

const FloatingBloom = () => {
    const flowerTypes = ['🌸', '🌺', '🌷', '✨', '•'];

    const petals = useMemo(() => {
        return Array.from({ length: 24 }).map((_, i) => ({
            id: i,
            left: `${Math.random() * 100}%`,
            delay: `${Math.random() * 20}s`,
            size: `${Math.random() * 25 + 10}px`,
            opacity: Math.random() * 0.5 + 0.2,
            flower: flowerTypes[i % flowerTypes.length],
        }));
    }, []); // 👈 runs only once

    return (
        <div className="bloom-container">
            <div className="glow-orb" style={{ top: '5%', left: '10%' }}></div>
            <div className="glow-orb" style={{ top: '40%', right: '15%', animationDelay: '3s', width: '300px' }}></div>
            <div className="glow-orb" style={{ bottom: '5%', left: '20%', animationDelay: '5s' }}></div>

            {petals.map((p) => (
                <span
                    key={p.id}
                    className="petal"
                    style={{
                        left: p.left,
                        animationDelay: p.delay,
                        fontSize: p.size,
                        opacity: p.opacity,
                    }}
                >
                    {p.flower}
                </span>
            ))}
        </div>
    );
};
const Toast = Swal.mixin({
    toast: true,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});
const ToastShow = (type, message) =>
    Toast.fire({ icon: type, title: message });
export default function SibolRegistration() {
    const gcashNum = "09970985227";
    const gcashName = "Manuel Christian M.";
    const levels = ["G - Novice", "F - Beginner", "E - High Beginner", "D - Low Intermediate", "C - Intermediate", "B - High Intermediate", "A - Advanced"];
    const { user, loading, loginGoogle, logout } = useAuth();
    const [step, setStep] = useState(1);
    const [level, setLevel] = useState(`Level ${levels[user?.level - 1]}` || ""); // Default empty for validation
    const previewType = 'primary';
    const [zoomedImage, setZoomedImage] = useState(null); // Stores the image URL or null
    const [showSizeChart, setShowSizeChart] = useState(false);
    const [errors, setErrors] = useState({});
    const [paymentMethod, setPaymentMethod] = useState('now'); // 'now' or 'later'
    const [regloading, setregLoading] = useState(false);
    const [existingReg, setExistingReg] = useState(null);
    const [checking, setChecking] = useState(true);
    const [payLoading, setPayLoading] = useState(false);
    const [gcashRefInput, setGcashRefInput] = useState("");
    const [payError, setPayError] = useState("");
    const [showQRModal, setShowQRModal] = useState(false);
    const [timeLeft, setTimeLeft] = useState(null);
    const [isLaunched, setIsLaunched] = useState(false);

    const [loggingIn, setLoggingIn] = useState(false);
    useEffect(() => {
        const targetDate = new Date("March 28, 2026 00:00:00").getTime();

        const interval = setInterval(() => {
            const now = new Date().getTime();
            const distance = targetDate - now;

            if (distance <= 0) {
                clearInterval(interval);
                setIsLaunched(true);
                setTimeLeft(null);
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((distance / (1000 * 60)) % 60);
            const seconds = Math.floor((distance / 1000) % 60);

            setTimeLeft({ days, hours, minutes, seconds });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const handleDownloadQR = () => {
        const link = document.createElement('a');

        const qrSrc = existingReg
            ? (existingReg.registrationFee === 1099 ? QR1099 : QR1199)
            : (REG_FEE === 1099 ? QR1099 : QR1199);

        link.href = qrSrc;
        link.download = 'RRC-GCash-QR.png';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const [personalInfo, setPersonalInfo] = useState({
        fullName: user?.realName || "",
        email: user?.email || "",
        contactNumber: ''
    });

    const [jerseyForm, setJerseyForm] = useState({
        items: [{ size: '', name: '', type: 'Mandatory' }],
        gcashRef: ''
    });

    useEffect(() => {
        const checkRegistration = async () => {
            if (!user?.uid) return;

            setChecking(true);
            try {
                const q = query(
                    collection(db, "registrations"),
                    where("submittedBy", "==", user.uid),
                    orderBy("createdAt", "desc")
                );

                const snap = await getDocs(q);

                if (!snap.empty) {
                    // get first registration (assuming 1 per user)
                    const doc = snap.docs[0];
                    if (doc.data().isDeleted !== true) {
                        setExistingReg({ id: doc.id, ...doc.data() });

                        // 🔥 skip form → go to summary
                        setStep(5);
                    }
                }
            } catch (err) {
                console.error("Error checking registration:", err);
            } finally {
                setChecking(false);
            }
        };
        setLevel(user?.level ? `Level ${levels[user?.level - 1]}` : "");

        setPersonalInfo({
            fullName: user?.realName || "",
            email: user?.email || "",
            contactNumber: ""
        });
        checkRegistration();
    }, [user]);



    const getRegistrationDetails = () => {
        const today = new Date();

        const earlyStart = new Date("2026-03-17");
        const earlyEnd = new Date("2026-04-16");

        const regularStart = new Date("2026-04-17");
        const regularEnd = new Date("2026-04-30");

        if (today >= earlyStart && today <= earlyEnd) {
            return {
                fee: 1099,
                label: "Early Registration",
                deadline: earlyEnd,
                phase: "early"
            };
        }

        if (today >= regularStart && today <= regularEnd) {
            return {
                fee: 1199,
                label: "Regular Registration",
                deadline: regularEnd,
                phase: "regular"
            };
        }

        return {
            fee: 1199,
            label: "Closed / Late",
            deadline: regularEnd,
            phase: "closed"
        };
    };

    const submitPayment = async () => {
        if (!gcashRefInput.trim()) {
            setPayError("Reference number required");
            return;
        }

        setPayLoading(true);
        setPayError("");

        try {
            await updateDoc(doc(db, "registrations", existingReg.id), {
                paymentStatus: "pending_verification",
                gcashReference: gcashRefInput,
                paidAt: serverTimestamp()
            });

            // update UI instantly
            setExistingReg(prev => ({
                ...prev,
                paymentStatus: "pending_verification",
                gcashReference: gcashRefInput
            }));

        } catch (err) {
            console.error(err);
            setPayError("Payment update failed");
        } finally {
            setPayLoading(false);
        }
    };

    const formatDate = (date) => {
        return date.toLocaleDateString("en-PH", {
            month: "long",
            day: "numeric"
        });
    };
    // --- VALIDATION LOGIC ---
    const validateStep = () => {
        let newErrors = {};
        if (step === 1 && !level) newErrors.level = "Please select your skill level";

        if (step === 2) {
            if (!personalInfo.fullName.trim()) newErrors.fullName = "Full name is required";
            if (!/^\S+@\S+\.\S+$/.test(personalInfo.email)) newErrors.email = "Invalid email format";
            if (personalInfo.contactNumber.length < 10) newErrors.contact = "Invalid contact number";
        }

        if (step === 3) {
            const invalidItem = jerseyForm.items.find(item =>
                !item.name.trim() || !item.size
            );

            if (invalidItem) {
                newErrors.jersey = "Please complete all jersey details (name and size)";
            }
        }

        if (step === 4) {
            if (paymentMethod === 'now' && !jerseyForm.gcashRef.trim()) {
                newErrors.gcash = "Reference number required for immediate payment";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const next = () => {
        if (validateStep()) setStep(s => s + 1);
    };

    const prev = () => {
        setErrors({});
        setStep(s => s - 1);
    };
    const submitRegistration = async () => {
        if (regloading) return; // prevent double click
        let newErrors = {};
        if (step === 4) {
            if (paymentMethod === 'now' && !jerseyForm.gcashRef.trim()) {
                newErrors.gcash = "Reference number required for immediate payment";
                setErrors(newErrors);
                return;
            }
        }

        setregLoading(true);

        try {
            await addDoc(collection(db, "registrations"), {
                level,
                personalInfo,
                jerseyForm,
                paymentMethod,
                total,
                registrationType: REG_LABEL,
                registrationFee: REG_FEE,

                // 🔥 NEW FIELDS FOR PAYMENT SYSTEM
                paymentStatus: paymentMethod === "now" ? "pending_verification" : "unpaid",
                gcashReference: paymentMethod === "now" ? jerseyForm.gcashRef : null,
                paidAt: paymentMethod === "now" ? serverTimestamp() : null,

                // 🔥 SYSTEM
                submittedBy: user.uid,
                createdAt: serverTimestamp(),
            });

            //await sendEmail(); // wait for emails (better UX)

            setStep(5);
        } catch (error) {
            console.error("Error saving:", error);
        } finally {
            setregLoading(false);
        }
    };



    const regDetails = getRegistrationDetails();
    const DEADLINE = formatDate(regDetails.deadline);
    const PHASE = regDetails.phase;
    const REG_FEE = regDetails.fee;
    const REG_LABEL = regDetails.label;
    const EXTRA_J = 750;
    const total = REG_FEE + ((jerseyForm.items.length - 1) * EXTRA_J);
    const peso = (n) => `₱${n.toLocaleString()}`;
    if (loading) {
        return (
            <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: "var(--app-bg)", opacity: 0.9 }}>
                <div className="spinner-border" style={{ color: THEME_COLOR }} />
            </div>
        );
    }
    if (!user) {
        return (
            <>
                <AuthLanding
                    themeColor={THEME_COLOR}
                    loggingIn={loggingIn}
                    onGoogleLogin={async () => {
                        setLoggingIn(true);
                        try {
                            await loginGoogle();
                        } catch (e) {
                            ToastShow("error", "Login failed. Please try again.");
                        } finally {
                            setLoggingIn(false);
                        }
                    }}
                />
            </>
        );
    }

    if (checking) {
        return (
            <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: "var(--app-bg)", opacity: 0.9 }}>
                <div className="spinner-border" style={{ color: THEME_COLOR }} />
            </div>
        );
    }

    return (
        <div
            className="min-vh-100 pb-5"
            style={{
                backgroundColor: "var(--app-bg)"
            }}
        >
            <AppHeader
                user={user}
                title={"Sibol"}
                subtitle={"Pangalawang Yugto"}
                clubId={CLUB_ID}
                sessionId={null}
                logout={logout}
            />


            <div className="sibol-theme-wrapper">
                {/* --- VIDEO BACKGROUND LAYER --- */}
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="sibol-video-bg"
                >
                    <source src={VideoBG} type="video/mp4" />
                    {/* Fallback for older browsers */}
                    Your browser does not support the video tag.
                </video>
                <FloatingBloom />

                <div className="container position-relative py-5" style={{ zIndex: 2 }}>



                    <header className="text-center pb-4" style={{ marginBottom: '-50px', marginTop: '-40px' }}>
                        <img src="/img/rrc.png" alt="RRC" className="rrc-main-logo mb-2" />
                        <h1><img src={Sibol} alt="RRC" className="rrc-main-logo mb-2" /></h1>
                        {/* <h1 className="sibol-title">SIBOL</h1>
                    <p className="rrc-presents-text">PANGALAWANG YUGTO</p> */}
                    </header>
                    {!existingReg && !isLaunched && (
                        <div className="container mt-5 d-flex justify-content-center px-4 mb-5">
                            <div className="premium-glass-card animate-fade-in text-center py-5">
                                {timeLeft && (
                                    <div className="mt-4">
                                        <div className="d-flex justify-content-center gap-3 text-white fw-bold">
                                            <div>
                                                <div className="fs-3">{timeLeft.days}</div>
                                                <small>Days</small>
                                            </div>
                                            <div>
                                                <div className="fs-3">{timeLeft.hours}</div>
                                                <small>Hours</small>
                                            </div>
                                            <div>
                                                <div className="fs-3">{timeLeft.minutes}</div>
                                                <small>Min</small>
                                            </div>
                                            <div>
                                                <div className="fs-3">{timeLeft.seconds}</div>
                                                <small>Sec</small>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <hr></hr>

                                <div className="logo-wrapper mb-4">
                                    <img src={SibolIcon} alt="Sibol" className="floating-logo" />
                                    <div className="success-ring opacity-25"></div>
                                </div>



                                <h2 className="fw-900 tracking-tight m-0 text-white">
                                    Coming Soon
                                </h2>

                                <p className="premium-subtitle px-3 mt-2">
                                    🌸 <strong>Sibol: Pangalawang Yugto</strong> registration is opening soon.
                                    Get ready to secure your slot and be part of the next wave.
                                </p>

                                <p className="small opacity-50 mt-2 mb-0">
                                    Stay tuned for the official launch announcement.
                                </p>

                                <div className="mt-4 pt-2">
                                    <div className="status-badge-premium unpaid d-inline-block">
                                        Launching Soon 🚀
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* 1. PROGRESS BAR SECTION */}
                    {existingReg && isLaunched && (
                        <div className="container mt-5 d-flex justify-content-center px-4 mb-5">
                            <div className="premium-glass-card animate-fade-in">

                                {/* Header Section */}
                                <div className="text-center mb-4">
                                    <div className="logo-wrapper mb-3">
                                        <img src={SibolIcon} alt="RRC" className="floating-logo" />
                                        <div className="success-ring"></div>
                                    </div>
                                    <h2 className="fw-900 tracking-tight m-0">Registration Active</h2>
                                    <p className="premium-subtitle">You are already registered for this event.</p>
                                </div>

                                {/* Bento Grid Stats */}
                                <div className="stats-bento mb-4">
                                    <div className="bento-item main">
                                        <span className="bento-label">Player</span>
                                        <div className="bento-value">{existingReg.personalInfo?.fullName}</div>
                                    </div>
                                    <div className="bento-item">
                                        <span className="bento-label">Level</span>
                                        <div className="bento-value text-purple-sibol">{existingReg.level}</div>
                                    </div>
                                    <div className="bento-item">
                                        <span className="bento-label">Jersey</span>
                                        <div className="bento-value">{existingReg.jerseyForm?.items[0]?.name}</div>
                                        <div className="bento-value">{existingReg.jerseyForm?.items[0]?.size}</div>
                                    </div>
                                    <div className="bento-item">
                                        <span className="bento-label">Fee</span>
                                        <div className="bento-value">{peso(existingReg.registrationFee)}</div>
                                    </div>
                                    <div className="bento-item">
                                        <span className="bento-label">Status</span>
                                        <div className={`status-badge-premium ${existingReg.paymentStatus}`}>
                                            {existingReg.paymentStatus?.replace('_', ' ')}
                                        </div>
                                    </div>
                                </div>

                                <div className="bento-item col-span-full py-2 bg-transparent shadow-none border-none">
                                    <span className="bento-label text-xs opacity-70 text-center w-full">
                                        Need changes? Message us in our Messenger community chat.
                                    </span>
                                </div>
                                <hr></hr>
                                {/* Action States */}
                                <div className="action-area">
                                    {existingReg.paymentStatus === "unpaid" && (
                                        <div className="gcash-payment-card p-3 animate-fade-in">
                                            <div className="d-flex align-items-center gap-2 mb-3">
                                                <div className="gcash-dot"></div>
                                                <span className="small fw-bold opacity-75">GCASH PAYMENT</span>
                                            </div>

                                            <div className="payment-details mb-3">
                                                <div className="d-flex justify-content-between">
                                                    <span className="opacity-50 small">Receiver</span>
                                                    <span className="fw-bold small text-white">{gcashName}</span>
                                                </div>
                                                <div className="d-flex justify-content-between mt-1 mb-3">
                                                    <span className="opacity-50 small">Account</span>
                                                    <span className="fw-bold small text-white">{gcashNum} <button
                                                        className="btn btn-sm px-2 py-1 border-0 bg-white bg-opacity-10 text-white rounded-2"
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(gcashNum);
                                                            ToastShow('success', 'GCash number copied');
                                                        }}
                                                    >
                                                        <i className="bi bi-clipboard"></i>
                                                    </button></span>

                                                </div>

                                                {/* New Save QR Button */}
                                                <button
                                                    className="btn-qr-save w-100 d-flex align-items-center justify-content-center gap-2"
                                                    onClick={() => setShowQRModal(true)} // Or your logic to trigger the save/view
                                                >
                                                    <i className="bi bi-qr-code-scan"></i>
                                                    <span>Save QR Code</span>
                                                </button>
                                            </div>

                                            <div className="position-relative">
                                                <input
                                                    className={`premium-input-field ${payError ? 'error' : ''}`}
                                                    placeholder="Enter GCash Ref Number"
                                                    value={gcashRefInput}
                                                    onChange={(e) => setGcashRefInput(e.target.value)}
                                                />
                                                {payError && <div className="error-text mt-1">{payError}</div>}
                                            </div>

                                            <button
                                                className="sibol-btn-primary w-100 mt-3"
                                                onClick={submitPayment}
                                                disabled={payLoading || !gcashRefInput.trim()}
                                            >
                                                {payLoading ? (
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                ) : (
                                                    <i className="bi bi-shield-lock-fill me-2"></i>
                                                )}
                                                Confirm Transaction
                                            </button>
                                        </div>
                                    )}

                                    {existingReg.paymentStatus === "pending_verification" && (
                                        <div className="status-banner-pending">
                                            <div className="spinner-grow spinner-grow-sm me-2" role="status"></div>
                                            Verification in progress...
                                        </div>
                                    )}

                                    {existingReg.paymentStatus === "paid" && (
                                        <div className="status-banner-success">
                                            <i className="bi bi-check-circle-fill me-2"></i>
                                            Payment Verified & Confirmed
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    )}
                    {!existingReg && isLaunched && (
                        <>
                            <div className="row justify-content-center mb-4" style={{ marginTop: '30px' }}>
                                <div className="col-lg-6 col-md-8 px-4">
                                    <div className="d-flex justify-content-between mb-2">
                                        <span className="tiny-label opacity-75">Step {step} of 5</span>
                                        <span className="tiny-label text-purple-sibol fw-bold">
                                            {step === 1 && "Skill"} {step === 2 && "Identity"} {step === 3 && "Jersey"} {step === 4 && "Payment"} {step === 5 && "Summary"}
                                        </span>
                                    </div>
                                    <div className="stepper-progress-bg">
                                        <div className="stepper-progress-fill" style={{ width: `${(step / 5) * 100}%` }}></div>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center pb-5">
                                <div className="col-lg-6 col-md-8">

                                    {/* STEP 1: SKILL LEVEL */}
                                    {step === 1 && (
                                        <div className="glass-card p-4 p-md-5 animate-fade-in text-center">
                                            <h4 className="fw-800 mb-2 text-light">Skill Classification</h4>
                                            <p className="tiny-label opacity-50 mb-3">Scroll to select your level</p>
                                            <div className="level-scroll-container">
                                                <div className="level-grid">
                                                    {levels.map(l => (
                                                        <div key={l} className={`level-card ${level === `Level ${l}` ? 'active' : ''}`} onClick={() => setLevel(`Level ${l}`)}>
                                                            {l}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            {errors.level && <p className="error-text mt-2">{errors.level}</p>}
                                            <button className="sibol-btn w-100 mt-4" onClick={next}>Continue</button>
                                        </div>
                                    )}

                                    {/* STEP 2: PERSONAL INFO */}
                                    {step === 2 && (
                                        <div className="glass-card p-4 p-md-5 animate-fade-in">
                                            <h4 className="fw-800 mb-4 text-light">Participant Details</h4>
                                            <div className="mb-4">
                                                <label className="tiny-label opacity-50">Full Name</label>
                                                <input placeholder="Racket Dela Cruz" className={`form-control sibol-input ${errors.fullName ? 'border-danger' : ''}`}
                                                    value={personalInfo.fullName} onChange={(e) => setPersonalInfo({ ...personalInfo, fullName: e.target.value })} />
                                                {errors.fullName && <small className="text-danger fs-xs">{errors.fullName}</small>}
                                            </div>
                                            <div className="mb-4">
                                                <label className="tiny-label opacity-50">Email Address</label>
                                                <input placeholder="racketriotclub@gmail.com" className={`form-control sibol-input ${errors.email ? 'border-danger' : ''}`}
                                                    value={personalInfo.email} onChange={(e) => setPersonalInfo({ ...personalInfo, email: e.target.value })} />
                                                {errors.email && <small className="text-danger fs-xs">{errors.email}</small>}
                                            </div>
                                            <div className="mb-4">
                                                <label className="tiny-label opacity-50">Contact Number</label>
                                                <input placeholder="09291234567" className={`form-control sibol-input ${errors.contact ? 'border-danger' : ''}`}
                                                    value={personalInfo.contactNumber} onChange={(e) => setPersonalInfo({ ...personalInfo, contactNumber: e.target.value })} />
                                                {errors.contact && <small className="text-danger fs-xs">{errors.contact}</small>}
                                            </div>
                                            <div className="d-flex gap-3 mt-5">
                                                <button className="btn text-white-50 w-25" onClick={prev}>Back</button>
                                                <button className="sibol-btn w-75" onClick={next}>Continue</button>
                                            </div>
                                        </div>
                                    )}

                                    {/* STEP 3: JERSEY */}
                                    {step === 3 && (
                                        <div className="glass-card p-4 p-md-5 animate-fade-in">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h4 className="fw-800 m-0 text-light">Jersey</h4>
                                                <button
                                                    className="btn btn-link btn-sm text-purple-sibol fw-bold text-decoration-none p-0"
                                                    onClick={() => setShowSizeChart(true)}
                                                >
                                                    📏 Size Chart
                                                </button>
                                            </div>

                                            <div className="jersey-preview-container mb-4">
                                                <div
                                                    className="preview-window cursor-zoom-in"
                                                    onClick={() => setZoomedImage(previewType === 'primary' ? Jersey : Jersey2)}
                                                >
                                                    <img
                                                        src={previewType === 'primary' ? Jersey : Jersey2}
                                                        className="jersey-img-fluid"
                                                        alt="Jersey Preview"
                                                    />
                                                    <div className="preview-overlay">
                                                        <span className="tiny-label">🔍 Click to Enlarge</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="jersey-list mb-3">
                                                {jerseyForm.items.map((item, i) => (
                                                    <div key={i} className={`p-3 mb-3 rounded-4 ${i === 0 ? 'border-mandatory' : 'bg-black-20'}`}>
                                                        <div className="d-flex align-items-center gap-3">
                                                            {/* Jersey Name - Takes up most space */}
                                                            <div className="flex-grow-1">
                                                                <label className="tiny-label opacity-50 mb-1 d-block">Jersey Name</label>
                                                                <input
                                                                    className="form-control sibol-input bg-transparent border-0 px-0 fw-bold"
                                                                    placeholder="E.g. DELA CRUZ"
                                                                    value={item.name}
                                                                    onChange={e => {
                                                                        const items = [...jerseyForm.items];
                                                                        items[i].name = e.target.value.toUpperCase();
                                                                        setJerseyForm({ ...jerseyForm, items });
                                                                    }}
                                                                />
                                                            </div>

                                                            {/* Size Selector - Fixed width */}
                                                            <div style={{ width: '80px' }}>
                                                                <label className="tiny-label opacity-50 mb-1 d-block text-end">Size</label>
                                                                <select
                                                                    className={`form-select sibol-input border-0 bg-transparent px-0 text-end fw-bold ${!item.size ? 'is-invalid' : ''}`}
                                                                    value={item.size || ""}
                                                                    onChange={e => {
                                                                        const items = [...jerseyForm.items];
                                                                        items[i].size = e.target.value;
                                                                        setJerseyForm({ ...jerseyForm, items });
                                                                    }}
                                                                >
                                                                    <option value="" disabled>Select Size</option>

                                                                    {['12', '14', '16', '18', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'].map(s => (
                                                                        <option key={s} value={s} className="bg-dark">{s}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            {errors.jersey && <p className="error-text mb-3">{errors.jersey}</p>}

                                            <div className="d-flex gap-3">
                                                <button className="btn text-white-50 w-25" onClick={prev}>Back</button>
                                                <button className="sibol-btn w-75" onClick={next}>Continue</button>
                                            </div>
                                        </div>
                                    )}

                                    {/* STEP 4: PAYMENT */}
                                    {step === 4 && (
                                        <div className="glass-card p-4 p-md-5 animate-fade-in">
                                            <h4 className="fw-800 mb-4 text-light">Finalization</h4>

                                            {/* TOTAL SUMMARY */}
                                            <div className="p-4 rounded-4 mb-4 border-glass" style={{ background: 'linear-gradient(145deg, rgba(255,255,255,0.05) 0%, rgba(0,0,0,0.2) 100%)' }}>
                                                <div className="d-flex justify-content-between small mb-1 opacity-75">
                                                    <span className="text-light">Registration Fee ({REG_LABEL})</span>
                                                    <span className="fw-bold text-light">{peso(REG_FEE)}</span>
                                                </div>
                                                {jerseyForm.items.length > 1 && (
                                                    <div className="d-flex justify-content-between small mb-1 opacity-75">
                                                        <span>Extra Jerseys ({jerseyForm.items.length - 1})</span>
                                                        <span>{peso(EXTRA_J * (jerseyForm.items.length - 1))}</span>
                                                    </div>
                                                )}
                                                <hr className="opacity-25" />
                                                <div className="d-flex justify-content-between h4 fw-900 mb-0 text-purple-sibol">
                                                    <span>Total Due</span>
                                                    <span>{peso(total)}</span>
                                                </div>
                                            </div>

                                            {/* PAYMENT METHOD TOGGLE */}
                                            <div className="payment-toggle-wrapper mb-4">
                                                <label className="tiny-label opacity-50 mb-2 d-block">Choose Payment Option</label>
                                                <div className="d-flex gap-2">
                                                    <button
                                                        className={`flex-fill py-2 rounded-3 transition-all border-0 ${paymentMethod === 'now' ? 'bg-purple-sibol text-white' : 'bg-black-20 text-white-50'}`}
                                                        onClick={() => setPaymentMethod('now')}
                                                    >
                                                        Pay via GCash
                                                    </button>
                                                    <button
                                                        className={`flex-fill py-2 rounded-3 transition-all border-0 ${paymentMethod === 'later' ? 'bg-purple-sibol text-white' : 'bg-black-20 text-white-50'}`}
                                                        onClick={() => {
                                                            setPaymentMethod('later');
                                                            setErrors({ ...errors, gcash: null }); // Clear error if switching
                                                        }}
                                                    >
                                                        Pay Later
                                                    </button>
                                                </div>
                                            </div>

                                            {/* CONDITIONAL GCASH INPUT */}
                                            {paymentMethod === 'now' ? (
                                                // <div className="p-3 rounded-4 mb-4 border-glass animate-fade-in">
                                                <div className="p-4 rounded-4 mb-4 border-glass animate-fade-in" style={{ background: 'linear-gradient(145deg, rgba(255,255,255,0.05) 0%, rgba(0,0,0,0.2) 100%)' }}>
                                                    <div
                                                        className="payment-details p-4 rounded-4 mb-4 border-glass text-body"
                                                        style={{ background: 'linear-gradient(145deg, rgba(255,255,255,0.05) 0%, rgba(0,0,0,0.2) 100%)' }}
                                                    >

                                                        {/* Header */}
                                                        <div className="mb-3">
                                                            <span className="text-uppercase small opacity-75 text-light">GCash Payment</span>
                                                        </div>

                                                        {/* Receiver */}
                                                        <div className="d-flex justify-content-between small mb-2 opacity-75 text-light">
                                                            <span>Receiver</span>
                                                            <span className="fw-bold text-light">{gcashName}</span>
                                                        </div>

                                                        {/* Account */}
                                                        <div className="d-flex justify-content-between align-items-center small mb-3 opacity-75 text-light">
                                                            <span>Account</span>

                                                            <div className="d-flex align-items-center gap-2">
                                                                <span className="fw-bold text-light">{gcashNum}</span>

                                                                <button
                                                                    className="btn btn-sm px-2 py-1 border-0 bg-white bg-opacity-10 text-white rounded-2"
                                                                    onClick={() => {
                                                                        navigator.clipboard.writeText(gcashNum);
                                                                        ToastShow('success', 'GCash number copied');
                                                                    }}
                                                                >
                                                                    <i className="bi bi-clipboard"></i>
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <hr className="opacity-25 text-light" />

                                                        {/* QR Button */}
                                                        <button
                                                            className={`w-100 py-2 rounded-3 border-0 transition-all fw-semibold ${paymentMethod === 'now'
                                                                ? 'bg-purple-sibol text-white'
                                                                : 'bg-black-20 text-white-50'
                                                                }`}
                                                            onClick={() => setShowQRModal(true)}
                                                        >
                                                            <i className="bi bi-qr-code-scan"></i>
                                                            &nbsp;<span>Save QR Code</span>
                                                        </button>

                                                    </div>
                                                    {/* <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <span className="tiny-label">GCash: {gcashNum} {gcashName}</span>
                                                        <span className="badge bg-primary">Instant</span>
                                                    </div> */}
                                                    <input
                                                        className={`form-control sibol-input mt-2 ${errors.gcash ? 'border-danger' : ''}`}
                                                        placeholder="Reference Number"
                                                        value={jerseyForm.gcashRef}
                                                        onChange={e => setJerseyForm({ ...jerseyForm, gcashRef: e.target.value })}
                                                    />
                                                    {errors.gcash && <small className="text-danger fs-xs">{errors.gcash}</small>}
                                                </div>
                                            ) : (
                                                <div className="p-3 rounded-4 mb-4 border-dashed animate-fade-in text-center">

                                                    <div className="mb-2">
                                                        <span className={`badge fw-bold px-3 py-2 ${PHASE === "early" ? "bg-success" :
                                                            PHASE === "regular" ? "bg-warning text-dark" :
                                                                "bg-danger"
                                                            }`}>
                                                            {REG_LABEL} • {peso(REG_FEE)}
                                                        </span>
                                                    </div>

                                                    {paymentMethod === "later" && (
                                                        <>
                                                            <p className="small mb-1 opacity-75">
                                                                ⚠️ Your slot is <strong>reserved but not yet confirmed</strong>.
                                                            </p>

                                                            <p className="small mb-0 opacity-50">
                                                                Please complete your payment before <strong>{DEADLINE}</strong> to secure your participation.
                                                            </p>

                                                            {PHASE === "early" && (
                                                                <p className="small text-success mt-2 mb-0">
                                                                    🎉 You’re enjoying the early registration rate!
                                                                </p>
                                                            )}

                                                            {PHASE === "regular" && (
                                                                <p className="small text-warning mt-2 mb-0">
                                                                    ⏳ Slots are filling fast. Settle your payment soon.
                                                                </p>
                                                            )}

                                                            {PHASE === "closed" && (
                                                                <p className="small text-danger mt-2 mb-0">
                                                                    🚫 Registration period has ended.
                                                                </p>
                                                            )}
                                                        </>
                                                    )}

                                                </div>
                                            )}

                                            <div className="d-flex gap-3">
                                                <button className="btn text-white-50 w-25" onClick={prev} disabled={regloading}>Back</button>
                                                <button
                                                    className="sibol-btn w-75"
                                                    onClick={submitRegistration}
                                                    disabled={regloading}
                                                >
                                                    {regloading ? (
                                                        <span>
                                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                                            Processing...
                                                        </span>
                                                    ) : (
                                                        paymentMethod === 'now' ? 'Register & Pay' : 'Reserve Slot'
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {/* SUCCESS MESSAGE (Omitted for brevity, same as before) */}
                                    {step === 5 && (
                                        <div className="glass-card p-4 p-md-5 text-center animate-fade-in">
                                            <div className="success-icon mb-4" style={{ fontSize: '3rem' }}><img src={SibolIcon} alt="RRC" className="rrc-main-logo mb-2" /></div>
                                            <h2 className="fw-800 mb-2">Registration Confirmed.</h2>
                                            <p className="text-white-50 mb-4 small">Your registration for the upcoming tournament has been recorded.</p>

                                            {/* REGISTRATION SUMMARY BOX */}
                                            <div className="bg-black-20 rounded-4 p-4 mb-4 border-glass text-start">
                                                <div className="mb-3">
                                                    <label className="tiny-label opacity-50 d-block">Player Profile</label>
                                                    <span className="fw-bold h5 text-purple-sibol">{personalInfo.fullName}</span>
                                                    <span className="badge bg-white text-dark ms-2 align-middle">{level}</span>
                                                </div>

                                                <div className="row g-3">
                                                    <div className="col-6">
                                                        <label className="tiny-label opacity-50 d-block">Payment Status</label>
                                                        <span className={`fw-bold ${paymentMethod === 'now' ? 'text-success' : 'text-warning'}`}>
                                                            {paymentMethod === 'now' ? '● Paid' : '○ Pay Later'}
                                                        </span>
                                                    </div>
                                                    <div className="col-6 text-end">
                                                        <label className="tiny-label opacity-50 d-block">Total</label>
                                                        <span className="fw-bold">{peso(total)}</span>
                                                    </div>
                                                </div>

                                                <hr className="opacity-10" />

                                                <label className="tiny-label opacity-50 d-block mb-2">Jersey Details</label>
                                                {jerseyForm.items.map((item, i) => (
                                                    <div key={i} className="d-flex justify-content-between align-items-center mb-1">
                                                        <span className="small fw-bold">{item.name || 'NO NAME'}</span>
                                                        <span className="badge border-glass text-white-50">{item.size}</span>
                                                    </div>
                                                ))}
                                            </div>

                                            <button className="sibol-btn w-100" onClick={() => window.location.reload()}>
                                                Return
                                            </button>

                                            <p className="mt-3 tiny-label opacity-50">
                                                A confirmation has been sent to your email.
                                            </p>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </>
                    )}
                </div>
                {/* IMAGE ZOOM MODAL */}
                {zoomedImage && (
                    <div className="image-zoom-overlay animate-fade-in" onClick={() => setZoomedImage(null)}>
                        <div className="zoom-content-wrapper">
                            <button className="btn-close btn-close-white zoom-close" onClick={() => setZoomedImage(null)}></button>
                            <img src={zoomedImage} alt="Enlarged Preview" className="zoomed-image" />
                        </div>
                    </div>
                )}
                {/* SIZE CHART MODAL - Outside steps for better rendering */}
                {showSizeChart && (
                    <div className="size-chart-overlay animate-fade-in" onClick={() => setShowSizeChart(false)}>
                        <div className="glass-card p-0 overflow-hidden size-chart-content shadow-glow"
                            style={{ width: '90%', maxWidth: '420px' }}
                            onClick={e => e.stopPropagation()}>

                            {/* Header Section */}
                            <div className="modal-head d-flex justify-content-between align-items-center p-4 border-bottom border-white-10">
                                <div>
                                    <span className="sibol-subtitle mb-1 d-block">Find Your Fit</span>
                                    <h5 className="m-0 fw-800 text-uppercase tracking-wider text-white">Jersey Size Guide</h5>
                                </div>
                                <button className="close-x text-white opacity-50" onClick={() => setShowSizeChart(false)}>&times;</button>
                            </div>

                            {/* Chart Section */}
                            <div className="modal-body p-0">
                                {/* Header Row - Styled with your theme's purple tint */}
                                <div className="chart-row-sibol header-row-bg">
                                    <div className="col-label tiny-label m-0">SIZE</div>
                                    <div className="col-data tiny-label m-0 text-end">WIDTH (IN)</div>
                                    <div className="col-data tiny-label m-0 text-end">LENGTH (IN)</div>
                                </div>

                                {/* Data Rows with your Custom Scrollbar */}
                                <div className="level-scroll-container px-2" style={{ maxHeight: '380px' }}>
                                    {[
                                        { s: "12", w: 14, l: 21 }, { s: "14", w: 15, l: 22 },
                                        { s: "16", w: 16, l: 23 }, { s: "18", w: 17, l: 24 },
                                        { s: "XS", w: 18, l: 25 }, { s: "S", w: 19, l: 26 },
                                        { s: "M", w: 20, l: 27 }, { s: "L", w: 21, l: 28 },
                                        { s: "XL", w: 22, l: 29 }, { s: "2XL", w: 23, l: 30 },
                                        { s: "3XL", w: 24, l: 31 }, { s: "4XL", w: 25, l: 32 },
                                        { s: "5XL", w: 26, l: 33 }
                                    ].map((row, i) => (
                                        <div key={i} className="chart-row-sibol body-row-style">
                                            <div className="col-label fw-800 text-purple-sibol">{row.s}</div>
                                            <div className="col-data text-end text-white fw-600 opacity-75">{row.w}"</div>
                                            <div className="col-data text-end text-white fw-600 opacity-75">{row.l}"</div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="p-3 bg-black-20 text-center border-top border-white-10">
                                <p className="m-0 fs-xs text-white-50 italic">
                                    * Measurements are in inches.
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                {showQRModal && (
                    <div className="qr-overlay animate-fade-in" onClick={() => setShowQRModal(false)}>
                        <div className="qr-modal-content p-4 text-center" onClick={e => e.stopPropagation()}>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <span className="small fw-bold opacity-50">GCASH QR CODE</span>
                                <button className="btn-close" onClick={() => setShowQRModal(false)}></button>
                            </div>
                            {existingReg ? (
                                <div className="qr-container mb-4">
                                    <img src={existingReg?.registrationFee === 1099 ? QR1099 : QR1199} alt="GCash QR" className="img-fluid rounded-4 shadow-lg" />
                                </div>
                            ) : (
                                <div className="qr-container mb-4">
                                    <img src={REG_FEE === 1099 ? QR1099 : QR1199} alt="GCash QR" className="img-fluid rounded-4 shadow-lg" />
                                </div>
                            )}

                            <button className="sibol-btn-primary w-100 py-3" onClick={handleDownloadQR}>
                                <i className="bi bi-download me-2"></i>
                                Save to Gallery
                            </button>

                            <p className="mt-3 x-small opacity-50">Once saved, open GCash and upload this QR from your gallery.</p>
                        </div>
                    </div>
                )}
            </div>

            <BottomNav />
        </div>
    );
}